import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import autoBind from 'react-autobind'
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import { fetchArticles } from '../actions'
import ShowArticles from '../components/Articles/ShowArticles';


const propTypes = {
  dispatch: PropTypes.func.isRequired,
}

class ArticlesPage extends React.Component {
  constructor(){
    super();
    autoBind(this);
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount(){
    console.log('fetching Articles')
    this.props.dispatch(fetchArticles())
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="settings component" style={authPage}>
        <ShowArticles />
      </div>
    );
  }
}


ArticlesPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ArticlesPage.propTypes = propTypes;

export default connect()(ArticlesPage);



// WEBPACK FOOTER //
// ./src/containers/ArticlesPage.js